import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SortableGridBaseUniDriver extends BaseUniDriver {
  startFixedElementExists: () => Promise<boolean>;
  endFixedElementExists: () => Promise<boolean>;
}
